export default __webpack_public_path__ + "static/media/sitting-service.ef10088c.svg";